import React from 'react';
import { Search, Plus, ArrowLeft } from 'lucide-react';

interface DocumentsHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  showMetadata: boolean;
  onToggleMetadata: () => void;
  onAddFile: () => void;
  onBackClick: () => void;
}

const DocumentsHeader: React.FC<DocumentsHeaderProps> = ({
  searchQuery,
  onSearchChange,
  showMetadata,
  onToggleMetadata,
  onAddFile,
  onBackClick
}) => {
  return (
    <div className="bg-white sm:border-white border-b border-gray-200 p-3 sm:p-4 lg:p-6 !pb-2">
      <div className="flex flex-col gap-3 sm:gap-4 mb-4">
        <div>
          <div className='sm:block hidden'>
            <h1 className="text-15 font-semibold text-gray-900">Documents</h1>
            <p className="text-xs text-gray-600 mt-1">
              All files of the Knowledge are shown here.
            </p>
          </div>
          <div className="flex items-center justify-between lg:justify-start lg:gap-4 mb-2">
            <button onClick={onBackClick} className="lg:hidden p-2 text-gray-500 hover:text-gray-700">
              <ArrowLeft className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Search and Actions */}
      <div className='flex flex-row gap-3 justify-between items-center'>
        <div className="relative flex-1 sm:max-w-md">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div className="flex items-center justify-end gap-2 sm:gap-3">
          {/* <button
            onClick={onToggleMetadata}
            className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50"
          >
            <Eye className="w-4 h-4" />
            <span className="hidden sm:inline">Metadata</span>
          </button> */}

          <button
            onClick={onAddFile}
            className="flex items-center space-x-2 px-3 py-2 sm:px-4 sm:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
          >
            <Plus className="w-4 h-4" />
            <span className="">Add Document</span>
            {/* <span className="sm:hidden">Add</span> */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentsHeader;
